export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "tabs": {
            "summary": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resumen"])},
            "providers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proveedores"])}
          }
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to process list"])}
        }
      }
    }
  })
}